/*
 * Copyright 2022-2026. NXGN Management, LLC. All Rights Reserved.
 */

import { HttpHeaders } from "@angular/common/http";

export class REST_CONSTANTS {
  public static MERCHANT_BASE_URL_INTERNAL = "/provisioning-api/services/internal";
  public static MERCHANT_BASE_URL_V9 = "/provisioning-api/services/v9";
  public static MERCHANT_BASE_URL_V7 = "/provisioning-api/services/v7/application/rcm";
  public static MERCHANT_BASE_URL_V6 = "/provisioning-api/services/v6/application/rcm";
  public static MERCHANT_BASE_URL_V5 = "/provisioning-api/services/v5/application/rcm";
  public static MERCHANT_NEW_BASE_URL = "/provisioning-api/services/v3/application/rcm";
  public static MERCHANT_BASE_URL = "/provisioning-api/services/v2/application/rcm";
  public static MERCHANT_OLD_BASE_URL = "/provisioning-api/services/v1/application/rcm";
  public static IBF_REPORTING_BASE_URL = "/ibf-reporting/services/v1";
  public static MERCHANT_GATEWAY_PROXY_URL = "/gateway-proxy/services/v1";

  public static JSON_HEADER = new HttpHeaders({ "Content-Type": "application/json", Accept: "application/json" });
}

export class PRACTICE_MODULE_CONSTANT {
  public static DIRECTIVE_TEMPLATE_PATH =
    "app/mf/merchants/practice/users/mf-practice-user-modal-dialog.directive.html";
  public static PRACTICE_USERS_ADD_OR_EDIT_TEMPLATE_PATH = "app/mf/merchants/practice/users/addoredituser.html";
  public static PRACTICE_USERS_REMOVE_TEMPLATE_PATH = "app/mf/merchants/practice/users/removeuser.html";
  public static PRACTICE_MENU_ICON_PATH = "assets/img/supervised_user_circle_white_24dp.svg";
}

export class SECURITY_CONSTANTS {
  public static LOGGED_USER_ROLES = [
    {
      // ?? not sure what is this about
      value: "SYSTEM",
      code: "SYSTEM"
    },
    {
      // regular provisioning users
      value: "merchant_provisioning_admin",
      code: "PROVISION"
    },
    {
      // privileged provisioning users
      value: "merchant_provisioning_finance",
      code: "FINANCE"
    },
    {
      value: "merchant_provisioning_implementation",
      code: "IMPLEMENTATION"
    }
  ];
  public static PRACTICE_USER_ROLES = [
    {
      name: "Point-of-Sale Admin",
      value: "PRACTICE_POS_ADMIN"
    },
    {
      name: "Practice Summary Report",
      value: "PSR"
    }
  ];
}

export class CREDIT_CARD_CONSTANTS {
  public static CREDIT_CARDS = {
    VISA: {
      value: "visa",
      title: "Visa",
      code: "VISA",
      image: "cards/visa.png"
    },
    MCARD: {
      value: "mastercard",
      title: "Master Card",
      code: "MCARD",
      image: "cards/mcard.png"
    },
    AMEX: {
      value: "amex",
      title: "American Express",
      code: "AMEX",
      image: "cards/amex.png"
    },
    DISCV: {
      value: "discover",
      title: "Discover",
      code: "DISCV",
      image: "cards/discv.png"
    }
  };
}

export class MERCHANT_CONSTANTS {
  public static WORLDPAY = "ELEMENT";
  public static PAYPAL = "PAYPAL";
  public static INSTAMED = "INSTAMED";
  public static GLOBALPAYMENTS = "Global Payments";
  public static QBPAY = "QBPAY";
  public static Combined = "Combined";
  public static FundingDeposits = "Funding Deposits";
  public static FeeWithdrawals = "Fee Withdrawals";
  public static PAY_API_CUSTOMERS = [{ id: 0, customerName: "NG Pay" }];
  public static SIC_MCC_CODE = {
    8011: {
      label: "Doctors"
    },
    8021: {
      label: "Dentists, Orthodontists"
    },
    8031: {
      label: "Osteopaths"
    },
    8041: {
      label: "Chiropractors"
    },
    8042: {
      label: "Optometrists, Ophthalmologist"
    },
    8043: {
      label: "Opticians, Eyeglasses"
    },
    8049: {
      label: "Chiropodists, Podiatrists"
    },
    8050: {
      label: "Nursing/Personal Care"
    },
    8062: {
      label: "Hospitals"
    },
    8071: {
      label: "Medical and Dental Labs"
    },
    8099: {
      label: "Medical Services"
    }
  };
  public static SoleProprietorship = "SoleProprietorship";
  public static PrivateCorporation = "PrivateCorporation";
  public static LLC = "LLC";
  public static Partnership = "Partnership";
  public static NonProfit = "NonProfit";
  public static UP = "UP";
  public static FINANCE = "FINANCE";
}

export class REPORTS_CONSTANTS {
  public static REPORTS_STATUS = {
    CREATED: "CREATED",
    NOT_CREATED: "NOT_CREATED",
    SENT: "SENT",
    NOT_SENT: "NOT_SENT"
  };
  public static REPORTS_RESPONSE = { APPROVED: "APPROVED", DECLINED: "DECLINED" };
  public static REPORTS_FUNDS = { SETTLED: "SETTLED", PROCESSING: "PROCESSING", NOT_SETTLED: "NOT_SETTLED" };
}

export class PATTERN_CONSTANTS {
  public static NUMBER = "^([0-9]*)$";
  public static NUMBER_4 = "^([0-9]{4})$";
  public static NUMBER_10 = "^([2-9][0-9]{9})$";
  public static MONEY =
    "^\\$?([1-9]{1}[0-9]{0,2}(\\,[0-9]{3})*(\\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\\.[0-9]{0,2})?|0(\\.[0-9]{0,2})?|(\\.[0-9]{1,2})?)$";
  public static PERCENT_2_DECIMALS = "^[0-9]+(\\.[0-9]{0,2})?$";
  public static PERCENT_3_DECIMALS = "^[0-9]+(\\.[0-9]{0,3})?$";
}

export class TOKEN_CONVERSION_DATA {
  public static TITLE = "Proceed with Caution!";
  public static MESSAGE = {
    MAIN_MESSAGE:
      "By performing this action, this client will go live with their InstaMed services for all PxP products within 24 hours of the date selected.",
    SUB_MESSAGES: [
      "Credit cards saved in the patient portal will be temporarily disrupted.",
      "Patients can still make payments via manual credit card entry.",
      "We suggest the practice sends a mass message within the portal to notify patients."
    ]
  };
}

export class ACH_ECHECK_DATA {
  public static TITLE = "ACH/eCheck Update Confirmation";
  public static MESSAGE =
    "ACH/eCheck payment functionality must be consistent for all MMIDs in a given PM Practice. " +
    "Updating this feature for this MMID will also update the following MMIDs:";
  public static TABLE_HEADERS = ["MMID", "Merchant Name"];
  public static CONFIRM_BUTTON_TEXT = "Confirm";
  public static CANCEL_BUTTON_TEXT = "Cancel";
  public static ERROR_RETRIEVE = "Failed to retrieve associated MMIDs.";
}

export class AMEX_DATA {
  public static TITLE = "AMEX Update Confirmation";
  public static MESSAGE =
    "AMEX payment functionality must be consistent for all MMIDs in a given PM Practice. " +
    "Updating this feature for this MMID will also update the following MMIDs:";
  public static TABLE_HEADERS = ["MMID", "Merchant Name"];
  public static CONFIRM_BUTTON_TEXT = "Confirm";
  public static CANCEL_BUTTON_TEXT = "Cancel";
  public static ERROR_RETRIEVE = "Failed to retrieve associated MMIDs.";
}

export class ACH_AMEX_COMBINED_DATA {
  public static TITLE = "ACH/eCheck & AMEX Update Confirmation";
  public static MESSAGE =
    "ACH/eCheck and AMEX payment functionality must be consistent for all MMIDs in a given PM Practice. " +
    "Updating these features for this MMID will also update the following MMIDs:";
  public static TABLE_HEADERS = ["MMID", "Merchant Name"];
  public static CONFIRM_BUTTON_TEXT = "Confirm";
  public static CANCEL_BUTTON_TEXT = "Cancel";
  public static ERROR_RETRIEVE = "Failed to retrieve associated MMIDs.";
}

export class DIRECT_BATCHING_DATA {
  public static TITLE = "Practice-Level Update Notice";
  public static MESSAGE =
    "Direct Batching is configured at the practice level. " +
    "Any change made to this setting will be applied to all MMIDs associated with this practice in Merchant Provisioning, not just the MMID you are currently editing. " +
    "The list of all MMIDs this edit will be applied if you proceed are:";
  public static TABLE_HEADERS = ["MMID", "Merchant Name", "Location Alias"];
  public static CONFIRM_BUTTON_TEXT = "Confirm";
  public static CANCEL_BUTTON_TEXT = "Cancel";
  public static ERROR_RETRIEVE = "Failed to retrieve associated MMIDs.";
}

export class ACH_DIRECT_BATCHING_COMBINED_DATA {
  public static TITLE = "ACH/eCheck & Direct Batching Update Confirmation";
  public static MESSAGE =
    "ACH/eCheck and Direct Batching payment functionality must be consistent for all MMIDs in a given PM Practice. " +
    "Updating these features for this MMID will also update the following MMIDs:";
  public static TABLE_HEADERS = ["MMID", "Merchant Name", "Location Alias"];
  public static CONFIRM_BUTTON_TEXT = "Confirm";
  public static CANCEL_BUTTON_TEXT = "Cancel";
  public static ERROR_RETRIEVE = "Failed to retrieve associated MMIDs.";
}

export class AMEX_DIRECT_BATCHING_COMBINED_DATA {
  public static TITLE = "AMEX & Direct Batching Update Confirmation";
  public static MESSAGE =
    "AMEX and Direct Batching payment functionality must be consistent for all MMIDs in a given PM Practice. " +
    "Updating these features for this MMID will also update the following MMIDs:";
  public static TABLE_HEADERS = ["MMID", "Merchant Name", "Location Alias"];
  public static CONFIRM_BUTTON_TEXT = "Confirm";
  public static CANCEL_BUTTON_TEXT = "Cancel";
  public static ERROR_RETRIEVE = "Failed to retrieve associated MMIDs.";
}

export class ACH_AMEX_DIRECT_BATCHING_COMBINED_DATA {
  public static TITLE = "ACH/eCheck, AMEX & Direct Batching Update Confirmation";
  public static MESSAGE =
    "ACH/eCheck, AMEX, and Direct Batching payment functionality must be consistent for all MMIDs in a given PM Practice. " +
    "Updating these features for this MMID will also update the following MMIDs:";
  public static TABLE_HEADERS = ["MMID", "Merchant Name", "Location Alias"];
  public static CONFIRM_BUTTON_TEXT = "Confirm";
  public static CANCEL_BUTTON_TEXT = "Cancel";
  public static ERROR_RETRIEVE = "Failed to retrieve associated MMIDs.";
}

export class MERCHANT_MIGRATION_STATUS {
  public static COMPLETE = "COMPLETE";
  public static IN_PROGRESS = "IN_PROGRESS";
}

export const TOKEN_CONVERSION_CONFIRMED_MESSAGE = "Patient credit card tokens confirmed for conversion on";
